import MacAddress from './MacAddress'

export default MacAddress
